export default __webpack_public_path__ + "static/media/dashboard.19d1fc25.JPG";